import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PTs from 'prop-types';
import React from 'react';

import s from './References.scss';

class References extends React.Component {
  static propTypes = {
    referenceList: PTs.node,
    referenceTitle: PTs.node.isRequired,
  };

  static defaultProps = {
    referenceList: '',
  };

  state = {
    displayReferences: false,
  };

  toggleState = () => {
    this.setState(state => ({
      displayReferences: !state.displayReferences,
    }));
  };

  render() {
    const { referenceList, referenceTitle } = this.props;
    const { displayReferences } = this.state;
    return (
      <div>
        <button
          className={s.referenceTitle}
          onClick={this.toggleState}
          type="button"
        >
          {referenceTitle}
        </button>
        {displayReferences && (
          <div className={s.referenceList}>{referenceList}</div>
        )}
      </div>
    );
  }
}

export default withStyles(s)(References);
